export default __webpack_public_path__ + "static/n1-tag-9649351f0cdcf925015346c2b15659b3.svg";